<classic-report [report]="this.reportVariant" [reportName]="this.reportTitle"
  [defaultDisplayColumns]="this.defaultDisplayColumns" [dateFilterTypes]="this.dateFilters"
  [matSortActive]="this.matSortActive" [matSortDirection]="this.matSortDirection"
  [activeLearnerToggle]="this.activeLearnerToggle" [hasClassicFilters]="this.hasClassicFilters">
</classic-report>